import React, {useState} from 'react'
import { Modal, Button } from 'react-bootstrap';
import RenderHtmlFormattedText from './RenderHtmlFormattedText';

export default function PlainModal({title, text, handleClose, html_text_div_container_class=""}) {
    return (
        <>
            <Modal show="true" onHide={handleClose} centered className={` ${html_text_div_container_class === 'account_overview_view_more_text' ? 'modal-lg' : '' }`}>
                <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className="row mb-3">
                    <div className="col-md-12">
                        <div htmlFor="labelCompanyName" className="form-label custom_label">
                            {/* {text} */}
                            <RenderHtmlFormattedText htmlContent={text} text_div_class={html_text_div_container_class} />
                        </div>
                    </div>
                </div>
                </Modal.Body>
            </Modal>
        </>
  )
};